export const getIntroBottomNavLabel = (isIntroComplete?: boolean) => {
  return isIntroComplete ? "Continue lesson" : "I'm ready";
};
